import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Rocket, Megaphone, Compass, Landmark, FolderKanban, Languages, ShoppingBag, Lightbulb, ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n/LangContext";
import { Stagger, item } from "./Reveal";

export const SERVICE_ICONS = { creation: Lightbulb, lancement: Rocket, marketing: Megaphone, conseil: Compass, banque: Landmark, admin: FolderKanban, traduction: Languages, ecommerce: ShoppingBag };

export function ServiceGrid({ limit }) {
  const { t, to } = useLang();
  const list = limit ? t.services.items.slice(0, limit) : t.services.items;
  return (
    <Stagger className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" stagger={0.06}>
      {list.map((s, i) => {
        const Icon = SERVICE_ICONS[s.id];
        return (
          <motion.div key={s.id} variants={item}>
            <Link to={`${to("services")}#${s.id}`} className="card-soft group flex h-full flex-col" data-testid={`services-card-${i + 1}`}>
              <div className="flex items-start justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-teal-50 text-teal-700 transition-colors group-hover:bg-teal-600 group-hover:text-white"><Icon size={22} /></span>
                <ArrowUpRight size={18} className="text-slate-300 transition-[transform,color] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-teal-600" />
              </div>
              <p className="mt-6 text-xs font-semibold uppercase tracking-[0.15em] text-slate-400">{s.tagline}</p>
              <h3 className="mt-2 font-display text-lg font-bold text-slate-900 sm:text-xl">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">{s.desc}</p>
            </Link>
          </motion.div>
        );
      })}
    </Stagger>
  );
}
